import { cn } from "@/lib/utils";

const BASE = "https://r2.connectsocial.app/976/product-loan-icon";

type Props = {
  name: string;
  color?: "co" | "bl";
  className?: string;
  alt?: string;
  eager?: boolean;
};

/**
 * Renders a colored or B&W SVG icon from the project's CDN icon set.
 * Use Tailwind sizing classes (e.g. "h-4 w-4") on `className` to size it.
 */
export function Icon({ name, color = "bl", className, alt = "", eager = false }: Props) {
  return (
    <img
      src={`${BASE}/${name}-${color}.svg`}
      alt={alt}
      aria-hidden={alt ? undefined : true}
      loading={eager ? "eager" : "lazy"}
      decoding="async"
      width={16}
      height={16}
      className={cn("inline-block shrink-0 object-contain", className)}
    />
  );
}
